export default "__VITE_ASSET__40ad8de5__"